export const DefaultTransitionTime = 300;
